// src/encounter/structured-note/chart-fill-context.ts
//
// PROD-3040 · frame v2: the items the chart fills in this note section (lib/chart-population.ts), by linkId, for
// the note lines to draw read-only with their source. Empty → every item draws as before.
import { createContext } from 'react';
import type { QAnswerValue, QItem } from '@scripsteam/scrips-signal-ds';
import type { ChartFill } from '../lib/chart-population';
import { pickOptions } from './note-adapter';

export const ChartFillContext = createContext<Readonly<Record<string, ChartFill>>>({});

/** The filled value as the clinician reads it: the option's label, "Yes", or the number with its unit. */
export function chartFillDisplay(item: QItem, value: QAnswerValue): string {
  if (item.answerOption?.length) {
    const keys = Array.isArray(value) ? value.map(String) : [String(value)];
    const labels = pickOptions(item)
      .filter((o) => keys.includes(o.value))
      .map((o) => o.label);
    return labels.join(', ');
  }
  if (value === true) return 'Yes';
  const unit = (item as QItem & { unit?: string }).unit;
  return unit ? `${String(value)} ${unit}` : String(value);
}
